import { ISignInData } from "../../../services/API/signin";

export const statusData = [
  { statusID: 0, statusDescription: "All" },
  { statusID: 1, statusDescription: "Awaiting Review" },
  { statusID: 2, statusDescription: "Awaiting Approval" },
  { statusID: 3, statusDescription: "Approved" },
  { statusID: 4, statusDescription: "Completed" },
  { statusID: 5, statusDescription: "Rejected" },
  { statusID: 6, statusDescription: "Closed" },
  { statusID: 7, statusDescription: "Queried" },
  { statusID: 8, statusDescription: "Awaiting Receipt" },
];

/** Whether this user has any capability that makes the Expenses area relevant to them at all. */
export const canAccessExpenses = (userData: ISignInData): boolean =>
  userData.CanRaiseExpense === "True" ||
  userData.CanReviewExpense === "True" ||
  userData.CanPreApproveExpense === "True" ||
  userData.CanApproveExpense === "True" ||
  userData.CanViewAllExpenses === "True";

/** Whether this user can see anyone else's expenses at all (their role's queue, or literally all). */
export const canViewBeyondOwnExpenses = (userData: ISignInData): boolean =>
  userData.CanReviewExpense === "True" ||
  userData.CanPreApproveExpense === "True" ||
  userData.CanApproveExpense === "True" ||
  userData.CanViewAllExpenses === "True";

/**
 * The default list scope to request from the server for this user: "all" resolves, server-side,
 * to the caller's full permitted role scope (review/approval queue, or everything for
 * CanViewAllExpenses) - never literally every request for someone without an elevated role.
 * A pure requester only ever sees their own ("mine").
 */
export const getDefaultExpenseScope = (userData: ISignInData): "mine" | "all" =>
  canViewBeyondOwnExpenses(userData) ? "all" : "mine";

